export enum RegionType {
	EA = 'EA',
	WA = 'WA',
	SA = 'SA',
	TZ = 'TZ',
}
